<template>
  <v-dialog v-model="dialog" persistent width="1000">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" @click="onOpen" v-on="on"> Configure Kronos </v-btn>
    </template>
    <v-form
      ref="form"
      v-model="valid"
    >
      <v-card>
        <v-card-title>Configure Kronos</v-card-title>
        <v-card-text>
          <v-text-field
            label="Username"
            v-model="credentials.username"
          ></v-text-field>
          <v-text-field
            label="Password"
            v-model="credentials.password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            ref="password"
            :rules="[rules.required]"
          />
          <v-text-field
            label="Client ID"
            v-model="credentials.clientId"
          ></v-text-field>
          <v-text-field
            label="Client Secret"
            v-model="credentials.clientSecret"
            ref="clientSecret"
            :rules="[rules.required]"
          >
          </v-text-field>
          <v-text-field
            label="Appkey"
            v-model="credentials.appkey"
          ></v-text-field>
          <v-text-field
            label="Tenant"
            v-model="credentials.tenant"
          ></v-text-field>
          <v-text-field
            label="Hyperfind Name"
            v-model="credentials.hyperfindName"
          />
          <v-text-field
            label="Business Type (UAT vs PROD)"
            v-model="credentials.businessType"
          />
          <v-text-field
            label="UAT Business ID"
            v-model="credentials.uatBusinessId"
            v-if="credentials.businessType != 'UAT'"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container
            v-if="saving"
          >
          Saving credentials...
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>

          </v-container>
          <v-spacer></v-spacer>
          <v-btn color="normal" text @click="dialog = false"> Cancel </v-btn>
          <v-btn color="primary"
            text
            @click="onSaveCredentials"
            :disabled="saving"
          > Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      // credentials: {
      //   businessType: '',
      //   username: '',
      //   password: '',
      //   clientId: '',
      //   clientSecret: '',
      //   appkey: '',
      //   tenant: '',
      //   hyperfindName: '',
      //   uatBusinessId: '',
      // },
      dialog: false,
      showPassword: false,
      rules: {
        required: (value) => !!value || 'Required.',
      },
      valid: true,
    };
  },
  props: {
    credentials: Object,
    saving: Boolean,
  },
  methods: {
    onSaveCredentials() {
      if (this.$refs.form.validate()) {
        this.$emit('saveCredentials', this.credentials);
      }
    },
    onOpen() {
      this.$emit('updateBusiness');
    },
  },
};
</script>

<style scoped>
</style>
